import { useState } from 'react'

import CaretDownOutlinedIcon from '@ant-design/icons/CaretDownOutlined'

import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import { useMe } from '@shared/providers/src/MeProvider'
import { TaskStatus, taskStatusToLabel } from '@shared/utils'

import { useStatusUpdate } from '../Kanban.hooks'
import { useStatusChangeConfirmation } from './useStatusChangeConfirmation'

const taskStatusToColor = {
  [TaskStatus.ToDo]: 'secondary',
  [TaskStatus.InProgress]: 'primary',
  [TaskStatus.Waiting]: 'warning',
  [TaskStatus.Completed]: 'secondary',
  [TaskStatus.Expired]: 'error',
}

export default function StatusButton({ task, disabled = false }) {
  const me = useMe()
  const updateStatus = useStatusUpdate()
  const requestStatusChange = useStatusChangeConfirmation()

  const [anchor, setAnchor] = useState(null)
  const [openMenu, setOpenMenu] = useState(false)

  const status = task.status
  const assignedToMe = me.id === task.assignee?.id
  const canComplete = assignedToMe || me.superAdmin
  const canExpire = assignedToMe || me.superAdmin

  const move = (newStatus) => {
    setOpenMenu(false)
    requestStatusChange(task, newStatus, {
      onConfirm: (reason) => updateStatus.mutate({ id: task.id, newStatus, oldStatus: task.status, reason }),
    })
  }

  if (disabled) {
    return (
      <Button
        variant="outlined"
        color={taskStatusToColor[status]}
        disableRipple
        disableTouchRipple
        sx={{ width: 130, justifyContent: 'flex-start', cursor: 'default' }}
      >
        {taskStatusToLabel[status]}
      </Button>
    )
  }

  return (
    <>
      <Button
        ref={setAnchor}
        variant={status === TaskStatus.Completed ? 'outlined' : 'contained'}
        color={taskStatusToColor[status]}
        onClick={() => setOpenMenu(true)}
        endIcon={<CaretDownOutlinedIcon />}
        sx={{ width: 130, justifyContent: 'space-between' }}
      >
        {taskStatusToLabel[status]}
      </Button>
      <Menu anchorEl={anchor} open={openMenu} onClose={() => setOpenMenu(false)}>
        <MenuItem selected={status === TaskStatus.ToDo} onClick={() => move(TaskStatus.ToDo)}>
          To Do
        </MenuItem>
        <MenuItem selected={status === TaskStatus.InProgress} onClick={() => move(TaskStatus.InProgress)}>
          In Progress
        </MenuItem>
        <MenuItem selected={status === TaskStatus.Waiting} onClick={() => move(TaskStatus.Waiting)}>
          Waiting
        </MenuItem>
        {canComplete && (
          <MenuItem selected={status === TaskStatus.Completed} onClick={() => move(TaskStatus.Completed)}>
            Done
          </MenuItem>
        )}
        {canExpire && (
          <MenuItem selected={status === TaskStatus.Expired} onClick={() => move(TaskStatus.Expired)}>
            Expired
          </MenuItem>
        )}
      </Menu>
    </>
  )
}
